import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { BackendFilterListComponent } from './backend-filter-list/backend-filter-list.component';
import { CustomHostDynamicDirective } from './custom-host-dynamic/custom-host-dynamic.directive';
import { CustomHostDirective } from './custom-host/custom-host.directive';
import { FastsearchLayoutComponent } from './fastsearch-layout/fastsearch-layout.component';
import { FastsearchComponent } from './fastsearch/fastsearch.component';
import { FilterBetweenDateTimeRangeComponent } from './filter-between-date-time-range/filter-between-date-time-range.component';
import { FilterDateRangeComponent } from './filter-date-range/filter-date-range.component';
import { FilterListBatchComponent } from './filter-list-batch/filter-list-batch.component';
import { FilterListSearchComponent } from './filter-list-search/filter-list-search.component';
import { FilterListSideFilterPanelComponent } from './filter-list-side-filter-panel/filter-list-side-filter-panel.component';
import { FilterListSideFilterComponent } from './filter-list-side-filter/filter-list-side-filter.component';
import { FilterListTopFilterComponent } from './filter-list-top-filter/filter-list-top-filter.component';
import { FilterListComponent } from './filter-list/filter-list.component';
import { GridLayoutComponent } from './grid-layout/grid-layout.component';
import { InlineSearchLayoutMultipleComponent } from './inline-search-layout-multiple/inline-search-layout-multiple.component';
import { InlineSearchLayoutComponent } from './inline-search-layout/inline-search-layout.component';
import { InlineSearchNavbarComponent } from './inline-search-navbar/inline-search-navbar.component';
import { InlineSearchComponent } from './inline-search/inline-search.component';
import { ItemSelectionButtonComponent } from './item-selection-button/item-selection-button.component';
import { ListLayoutMultipleComponent } from './list-layout-multiple/list-layout-multiple.component';
import { ListLayoutSingleComponent } from './list-layout-single/list-layout-single.component';
import { PaginationListComponent } from './pagination-list/pagination-list.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { RangeSliderComponent } from './range-slider/range-slider.component';
import { SelectedFilterComponent } from './selected-filter/selected-filter.component';
import { SelectionBarComponent } from './selection-bar/selection-bar.component';
import { SimpleListComponent } from './simple-list/simple-list.component';
import { SliderComponent } from './slider/slider.component';
import { TopFilterListComponent } from './top-filter-list/top-filter-list.component';
import { FilterListGridSkeletonComponent } from './filter-list-grid-skeleton/filter-list-grid-skeleton.component';
import { FilterListSkeletonComponent } from './filter-list-skeleton/filter-list-skeleton.component';

@NgModule({
  declarations: [
    CustomHostDirective,
    CustomHostDynamicDirective,
    FilterListComponent,
    GridLayoutComponent,
    ListLayoutSingleComponent,
    FilterListSideFilterComponent,
    FilterListSearchComponent,
    FilterListBatchComponent,
    FilterListTopFilterComponent,
    TopFilterListComponent,
    SelectedFilterComponent,
    ListLayoutMultipleComponent,
    PaginationListComponent,
    FastsearchComponent,
    FastsearchLayoutComponent,
    SelectionBarComponent,
    ItemSelectionButtonComponent,
    BackendFilterListComponent,
    RangeSliderComponent,
    InlineSearchComponent,
    SafeHtmlPipe,
    InlineSearchLayoutComponent,
    InlineSearchNavbarComponent,
    InlineSearchLayoutMultipleComponent,
    FilterListSideFilterPanelComponent,
    SliderComponent,
    FilterDateRangeComponent,
    SimpleListComponent,
    FilterBetweenDateTimeRangeComponent,
    FilterListGridSkeletonComponent,
    FilterListSkeletonComponent
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgbModule, TranslateModule, NzSliderModule],
  exports: [
    FilterListComponent,
    CustomHostDirective,
    CustomHostDynamicDirective,
    ListLayoutSingleComponent,
    PaginationListComponent,
    TopFilterListComponent,
    FilterListSearchComponent,
    FilterListSideFilterComponent,
    FastsearchComponent,
    FastsearchLayoutComponent,
    ItemSelectionButtonComponent,
    SelectionBarComponent,
    SelectedFilterComponent,
    FilterListBatchComponent,
    FilterListTopFilterComponent,
    BackendFilterListComponent,
    InlineSearchComponent,
    SafeHtmlPipe,
    InlineSearchNavbarComponent,
    FilterListSideFilterPanelComponent,
    SliderComponent,
    RangeSliderComponent,
    SimpleListComponent,
    FilterListGridSkeletonComponent,
    FilterListSkeletonComponent
  ]
})
export class GungListModule {}
